import styles from './LoginErrorElement.module.css';

const ErrorElement = ({error, resetErrorBoundary}) => {

  console.log("error: ", error);
  console.log("resetErrorBoundary: ", resetErrorBoundary);

  return (
    <div
      className={`${styles.errorContainer} d-flex flex-column justify-content-center align-items-center`}
    >
      <h2 className="text-dark">A login error occurred.</h2>
      <div className={styles.errorImage}></div>
    </div>
  );
}

export default ErrorElement;